var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine13 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 672,
  height: 1,
  viewBox: "0 0 672 1",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: 0.5,
  x2: 672,
  y2: 0.5,
  stroke: "#0A3887"
})));
export { SvgLine13 as ReactComponent };
export default __webpack_public_path__ + "5c36c5fb259e2d04954f455145186135.svg";